import React from 'react';
import Square from './Square';

/***********************************************************************************************************
The Board component is rendered by the parent component Game. It receives props: square, onClick, and winningElements
*/

function Board (props) {       // Board is referenced by parent component Game and is passed props

    const { winningElements, squares, onClick } = props;

    function renderSquare(i) {                         // renderSquare is called by the render module below, it provides the i value
      
      const winningSquare = winningElements?.includes(i); // Determine if this is a winning square. If so, change the classname
      const className = winningSquare ? "winning-square" : "square"; // to change the color of winning squares
    
      return (
        <Square 
            value={squares[i]} // send value for each square on the board
            onClick={() => onClick(i)} // passing the function to call when clicked    
            className = {className}               // send className to square component
        />
      ); 
    };
    
      return ( // This section calls renderSquare above for each square to set value and the onclick property for each square
        <div>
          <div className="board-row">
            {renderSquare(0)}
            {renderSquare(1)}
            {renderSquare(2)}
          </div>
          <div className="board-row">
            {renderSquare(3)}
            {renderSquare(4)}
            {renderSquare(5)}
          </div>
          <div className="board-row">
            {renderSquare(6)}
            {renderSquare(7)}
            {renderSquare(8)}
          </div>
        </div>
      );
  }

  export default Board;